export default "__VITE_ASSET__f6f41dfc__"